module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero8.png?8ca269e4";